import TransferMenu from "./LocationMenu/TransferMenu";
import UpgradeMenu from "./LocationMenu/UpgradeMenu";
import { GameState } from "./GameState";
import { useContext } from "react";

const heatColors = [
  "#00FF00", // green
  "#11FF00",
  "#22FF00",
  "#33FF00",
  "#44FF00",
  "#55FF00",
  "#66FF00",
  "#77FF00",
  "#88FF00",
  "#99FF00",
  "#AAFF00",
  "#BBFF00",
  "#CCFF00",
  "#DDFF00",
  "#EEFF00",
  "#FFFF00", // yellow
  "#FFEE00",
  "#FFDD00",
  "#FFCC00",
  "#FFBB00",
  "#FFAA00",
  "#FF9900",
  "#FF8800",
  "#FF7700",
  "#FF6600",
  "#FF5500",
  "#FF4400",
  "#FF3300",
  "#FF2200",
  "#FF1100",
  "#FF0000", // red
];

const getHeatColor = (heat) => {
  const ind = Math.floor(heat * 3);
  if (ind < 0) {
    return heatColors[0];
  } else if (ind >= heatColors.length) {
    return heatColors[heatColors.length - 1];
  } else {
    return heatColors[ind];
  }
};

const Location = (props) => {
  const state = useContext(GameState);
  const { id, name, position, selected, selectLocation, active } = props;

  const divClass = active
    ? selected
      ? "locationbutton-sel"
      : "locationbutton"
    : "locationbutton-inactive";

  const bottomLabel =
    state.transferFrom === id
      ? "Select transfer destination"
      : "$" + Math.floor(state.locations[id].money).toLocaleString();

  const color = active ? getHeatColor(state.locations[id].heat) : "#BEBEBE";

  return (
    <div
      className={divClass}
      style={{ left: position.x, top: position.y, backgroundColor: color }}
      onClick={(evt) => {
        if (
          evt.target.className === "locationbutton" ||
          evt.target.className === "locationbutton-sel"
        ) {
          if (state.transferFrom === -1) {
            selectLocation();
          } else {
            state.finishTransfer(id);
          }
        }
      }}
    >
      <div className="locationlabel">{name}</div>
      <div className="locationmoney">{bottomLabel}</div>
      {selected &&
        state.locations[id].money > 0 &&
        state.selectedLocation > -1 && <TransferMenu id={id} />}
      {selected &&
        state.locations[id].money > 0 &&
        state.selectedLocation > -1 && <UpgradeMenu id={id} />}
    </div>
  );
};

export default Location;
